import React, { useState } from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import BookingTeaser from "../components/site/BookingTeaser";
import Legacy from "../components/site/Legacy";
import Pillars from "../components/site/Pillars";
import CoachBio from "../components/site/CoachBio";
import JuniorCoach from "../components/site/JuniorCoach";
import Gallery from "../components/site/Gallery";
import Timetable from "../components/site/Timetable";
import Membership from "../components/site/Membership";
import Booking from "../components/site/Booking";
import Notices from "../components/site/Notices";
import Merch from "../components/site/Merch";
import Footer from "../components/site/Footer";
import useScrollReveal from "../hooks/useScrollReveal";

// Wraps each section in a reveal div so it fades up as it scrolls in.
const Reveal = ({ children }) => (
  <div data-reveal>{children}</div>
);

export default function Home() {
  useScrollReveal();
  const [showJuniorCoach, setShowJuniorCoach] = useState(false);
  const toggleJuniorCoach = () => {
    setShowJuniorCoach((v) => {
      const next = !v;
      if (next) {
        // After React paints, scroll into view
        setTimeout(() => {
          const el = document.getElementById("junior-coach");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 80);
      }
      return next;
    });
  };
  return (
    <div className="bg-[#050505] text-white min-h-screen font-body">
      <Navbar />
      <main>
        {/* 1. Attention — hero animates on load already */}
        <Hero />
        <Reveal><BookingTeaser /></Reveal>

        {/* 2. Interest — trust story */}
        <Reveal><Legacy /></Reveal>
        <Reveal><Pillars /></Reveal>
        <Reveal>
          <CoachBio
            onToggleJuniorCoach={toggleJuniorCoach}
            juniorCoachOpen={showJuniorCoach}
          />
        </Reveal>
        {showJuniorCoach && (
          <Reveal><JuniorCoach /></Reveal>
        )}

        {/* 3. Desire — emotional proof */}
        <Reveal><Gallery /></Reveal>

        {/* 4. Action — practical + commitment */}
        <Reveal><Timetable /></Reveal>
        <Reveal><Membership /></Reveal>
        <Reveal><Booking /></Reveal>

        {/* 5. Retention / upsell */}
        <Reveal><Notices /></Reveal>
        <Reveal><Merch /></Reveal>
      </main>
      <Footer />
    </div>
  );
}
